import { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useToast } from './Toast';
import { useVendorWebSocket, type RealtimeNotification } from '../../hooks/useVendorWebSocket';

/**
 * Mounted once at the protected-route boundary. Opens the vendor
 * WebSocket while the user is authenticated, surfaces high-priority
 * notifications as toasts, and cleans up on unmount.
 *
 * Renders nothing.
 */
export function VendorRealtimeBridge() {
  const { isAuthenticated } = useAuth();
  const { toast } = useToast();

  useVendorWebSocket(isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) return;
    const handler = (e: Event) => {
      const ce = e as CustomEvent<RealtimeNotification>;
      const n = ce.detail;
      if (!n) return;
      // Toast for high-priority items so the vendor reacts immediately.
      // Lower-priority notifications still ping the bell counter via
      // React Query invalidation but don't interrupt.
      if (n.priority === 'high') {
        toast('info', n.title);
      }
    };
    window.addEventListener('vendoriq:notification', handler);
    return () => window.removeEventListener('vendoriq:notification', handler);
  }, [isAuthenticated, toast]);

  return null;
}
